import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectStakeholderActions from './project-stakeholder.actions';
import { ProjectStakeholderService } from '../../services/project-stakeholder.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectStakeholderEffects {
  loadProjectStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectStakeholderActions.loadProjectStakeholder),
      exhaustMap((_) =>
        this.projectStakeholderService.getProjectStakeholder().pipe(
          map((data) =>
            ProjectStakeholderActions.loadProjectStakeholderSuccess({
              projectStakeholder: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectStakeholderActions.loadProjectStakeholderFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectStakeholderActions.addProjectStakeholder),
      concatMap(({ newProjectStakeholder }) =>
        this.projectStakeholderService
          .createProjectStakeholder(newProjectStakeholder)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProjectStakeholderActions.addProjectStakeholderSuccess({
                newProjectStakeholder: data,
              });
            }),
            catchError((error) => {
              console.log('error ', error);

              return of(
                ProjectStakeholderActions.addProjectStakeholderFailure({
                  error: error.error.message,
                })
              );
            })
          )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProjectStakeholderActions.addProjectStakeholderSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProjectStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectStakeholderActions.updateProjectStakeholder),
      concatMap(({ updateProjectStakeholder }) =>
        this.projectStakeholderService
          .updateProjectStakeholder(updateProjectStakeholder)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProjectStakeholderActions.updateProjectStakeholderSuccess({
                updateProjectStakeholder: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectStakeholderActions.updateProjectStakeholderFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectStakeholderActions.updateProjectStakeholderSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProjectStakeholder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectStakeholderActions.removeProjectStakeholder),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectStakeholderService.deleteProjectStakeholder(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectStakeholderActions.removeProjectStakeholderSuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ProjectStakeholderActions.updateProjectStakeholderFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectStakeholderService: ProjectStakeholderService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
